import { useEffect } from 'react';

export const useHideScroll = (hide?: boolean) => {
	useEffect(() => {
		const html = document.getElementsByTagName('html')[0];
		html.style.overflow = hide ? 'hidden' : 'unset';
	}, [hide]);
};
